function sendMessage(messageType, data) {
	try {
		window.parent.postMessage(JSON.stringify({ messageType, data }), '*');
	} catch (ex) {
		console.log(ex);
	}
}

function log(eventData) {
	try {
		const msg = {
			messageType: 'log-message',
			log: { ...eventData, eventCategory: 'Widget' }
		};
		// console.log(msg)
		window.parent.postMessage(JSON.stringify(msg), '*');
	} catch (ex) {
		console.log(ex);
	}
}

export default { sendMessage, log };
